"use strict";
exports.__esModule = true;
exports.global_palette_black_300 = {
  "name": "--pf-v5-global--palette--black-300",
  "value": "#d2d2d2",
  "var": "var(--pf-v5-global--palette--black-300)"
};
exports["default"] = exports.global_palette_black_300;